const showsFullAccess = 'SHOWS_FULL_ACCESS',
  schedulesFullAccess = 'SCHEDULES_FULL_ACCESS',
  listsFullAccess = 'LISTS_FULL_ACCESS',
  docsFullAccess = 'DOCS_FULL_ACCESS',
  globalElementsFullAccess = 'GLOBAL_ELEMENTS_FULL_ACCESS',
  teleprompterFullAccess = 'FULL_SCREEN_FEATURED_VIEW_FULL_ACCESS',
  overUnderFullAccess = 'OVER_UNDER_FULL_ACCESS';

const all = [
  showsFullAccess,
  schedulesFullAccess,
  listsFullAccess,
  docsFullAccess,
  globalElementsFullAccess,
  teleprompterFullAccess,
  overUnderFullAccess,
];

export default {
  showsFullAccess,
  schedulesFullAccess,
  listsFullAccess,
  docsFullAccess,
  globalElementsFullAccess,
  teleprompterFullAccess,
  overUnderFullAccess,
  all,
};
